import React, { Component, Fragment } from 'react';
import {
  Grid,
  FormGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
  FormControl,
  Button,
} from '@material-ui/core';
import { toTitleCase } from 'Utils';

import Container from './components/Container';
import InnerContainer from '../components/InnerContainer';
import Footer from '../components/Footer';
import Header from '../../Header';
import Modal from 'Components/Modal';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import GridFix from '../../../../../../components/GridFix';

//Milan Andrejic
import axios from 'Axios';

import Snackbar from 'Snackbar';

class Step3 extends Component {
  state = {
    SnackbarMsg: '',
  };

  handleOpenSnackbar = () => {
    this.setState({ openSnackbar: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  getObjectIDs = obj => {
    return Object.keys(obj).filter(key => obj[key] === false);
  };

  getIDs = productRange => {
    let allIDs = [];
    allIDs = allIDs.concat(
      this.getObjectIDs(productRange.mountingPosition),
      this.getObjectIDs(productRange.mountingType),
      this.getObjectIDs(productRange.fittingType)
    );
    return allIDs;
  };

  askForNextStep = ({ acctok, productRange }) => () => {
    const falseIDs = this.getIDs(productRange);
    axios
      .post('registration/' + acctok, { disabledCriteria: falseIDs })
      .then(response => {
        if (response.data) this.props.next();
      })
      .catch(error => {
        console.error(error);
        this.setState(
          {
            SnackbarMsg: error.response
              ? error.response.data.message
              : 'Failed to connect to the database',
          },
          this.handleOpenSnackbar
        );
      });
  };

  componentDidMount = () => {
    if (
      this.props.registrationData.step === 'STEP_4' ||
      this.props.registrationData.step === 'FINISHED' ||
      this.props.registrationData.type === 'ARUP_REGISTRATION' ||
      (this.props.registrationData.type === 'COMPANY_USER_REGISTRATION' &&
        this.props.registrationData.step === 'STEP_3') ||
      this.props.registrationData.type === 'NON_ARUP_REGISTRATION'
    ) {
      this.props.next();
    }
  };

  selectAll = () => {
    const oldProductRange = this.props.values.productRange;

    const fittingType = {};
    const mountingPosition = {};
    const mountingType = {};

    Object.keys(oldProductRange.fittingType).forEach(
      prop => (fittingType[prop] = true)
    );

    Object.keys(oldProductRange.mountingPosition).forEach(
      prop => (mountingPosition[prop] = true)
    );

    Object.keys(oldProductRange.mountingType).forEach(
      prop => (mountingType[prop] = true)
    );

    const newProductRange = {
      ...oldProductRange,
      fittingType,
      mountingPosition,
      mountingType,
    };

    this.props.setValues({
      productRange: newProductRange,
    });
  };

  render() {
    const {
      values: { productRange },
      handleChange,
      step,
      // previous,
      acctok,
      registrationData,
    } = this.props;
    return (
      <Fragment>
        <Modal.Header>
          <Header activeStep={step.id} registrationData={registrationData} />
        </Modal.Header>
        <Modal.Body>
          <Container data-simplebar>
            <InnerContainer>
              <p>
                Please select your company product range. Luminaire Broker will
                use this information to send you queries for specific types of
                luminaires. You will only receive queries for luminaires that
                fit within the categories that you select below.
              </p>
              <Grid container direction="column">
                <GridFix item xs={12}>
                  <FormControl margin="normal" component="fieldset" fullWidth>
                    <FormLabel component="legend">Mounting position</FormLabel>
                    <Grid container>
                      {Object.entries(productRange.available.mountingPosition)
                        .sort((a, b) => a[1][1] - b[1][1])
                        .map((p, i) => (
                          <Grid key={i} item xs={4}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name={`productRange.mountingPosition.${p[0]}`}
                                    checked={
                                      productRange.mountingPosition[p[0]]
                                    }
                                    onChange={handleChange}
                                    value={p[0]}
                                  />
                                }
                                label={toTitleCase(p[1][0])}
                              />
                            </FormGroup>
                          </Grid>
                        ))}
                    </Grid>
                  </FormControl>
                </GridFix>
                <GridFix item xs={12}>
                  <FormControl margin="normal" component="fieldset" fullWidth>
                    <FormLabel component="legend">Luminaire type</FormLabel>
                    <Grid container>
                      {Object.entries(productRange.available.fittingType)
                        .sort((a, b) => a[1][1] - b[1][1])
                        .map((p, i) => (
                          <Grid key={i} item xs={4}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name={`productRange.fittingType.${p[0]}`}
                                    checked={productRange.fittingType[p[0]]}
                                    onChange={handleChange}
                                    value={p[0]}
                                  />
                                }
                                label={toTitleCase(p[1][0])}
                              />
                            </FormGroup>
                          </Grid>
                        ))}
                    </Grid>
                  </FormControl>
                </GridFix>
                <GridFix item xs={12}>
                  <FormControl margin="normal" component="fieldset" fullWidth>
                    <FormLabel component="legend">Mounting type</FormLabel>
                    <Grid container>
                      {Object.entries(productRange.available.mountingType)
                        .sort((a, b) => a[1][1] - b[1][1])
                        .map((p, i) => (
                          <Grid key={i} item xs={4}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name={`productRange.mountingType.${p[0]}`}
                                    checked={productRange.mountingType[p[0]]}
                                    onChange={handleChange}
                                    value={p[0]}
                                  />
                                }
                                label={toTitleCase(p[1][0])}
                              />
                            </FormGroup>
                          </Grid>
                        ))}
                    </Grid>
                  </FormControl>
                </GridFix>
              </Grid>
            </InnerContainer>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Footer>
            <Button onClick={this.selectAll} variant="contained">
              Select All
            </Button>
            <Button
              onClick={this.askForNextStep({
                acctok,
                productRange,
              })}
              variant="contained"
              color="primary"
            >
              Next
            </Button>
          </Footer>
        </Modal.Footer>

        <Snackbar
          open={this.state.openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={this.state.SnackbarMsg}
        />
      </Fragment>
    );
  }
}

export default Step3;
